import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { AppService } from '../services/app.service';
import { CustomHeader } from '../models/header.enum';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
    let requestsCount = 0;
    let skipSpinner = false;
    const appService = inject(AppService);
    if (req.headers.has(CustomHeader.SkipLoadingHeader)) {
      req.headers.delete(CustomHeader.SkipLoadingHeader);
      skipSpinner = true;
    }
    if (!skipSpinner) {
      if (requestsCount <= 0) {
        appService.busy.set(true);
      }
      requestsCount++;
    }

    return next(req).pipe(
      finalize(() => {
        if (!skipSpinner) {
          requestsCount--;
          if (requestsCount <= 0) {
            appService.busy.set(false);
          }
        }
      })
    );
}
